import NewsletterForm from "@/components/feature/NewsletterForm";

export default function Newsletter() {
  return (
    <section className="relative w-full overflow-hidden" aria-label="订阅漫画岛更新">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20abstract%20manga%20comic%20paper%20texture%20with%20soft%20geometric%20shapes%2C%20terracotta%20and%20cream%20color%20palette%2C%20minimal%20stylized%20graphic%20background%2C%20light%20and%20airy&width=1600&height=600&seq=home-newsletter-2026&orientation=landscape"
          alt="漫画岛订阅背景"
          title="订阅漫画岛更新"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-primary-950/40"></div>
      </div>
      <div className="relative mx-auto w-full max-w-3xl px-4 py-14 text-center md:px-6 md:py-20">
        <span className="flex items-center justify-center gap-2 text-sm font-medium text-accent-400">
          <i className="ri-mail-send-line" aria-hidden="true"></i> 订阅漫画岛
        </span>
        <h2 className="mt-3 font-heading text-2xl font-black text-background-50 md:text-3xl">不错过任何一部宝藏漫画</h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-100 md:text-base">
          订阅后，我们会在新书评、热门安利与追更提醒上线时第一时间通知你，和 {""}
          同好一起发现好漫画。
        </p>
        <div className="mt-7 max-w-xl mx-auto">
          <NewsletterForm />
        </div>
      </div>
    </section>
  );
}